import React, { Component } from 'react';
import AdminNavigationBar from './AdminNavigationBar';
import { locationFilters, rankFilters } from '../utils/tournaments';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css';

import './tournament-creator.css';
import moment from 'moment/src/moment';

class TournamentCreator extends Component {

  constructor() {
    super();
    this.state = emptyState();
    this.togglePayments = this.togglePayments.bind(this);
    this.onNonAssociatedPlayerPriceChange = this.onNonAssociatedPlayerPriceChange.bind(this);
    this.onRegularPriceChange = this.onRegularPriceChange.bind(this);
    this.onYoungsterPriceChange = this.onYoungsterPriceChange.bind(this);
    this.onJuniorPriceChange = this.onJuniorPriceChange.bind(this);
    this.onSeniorPriceChange = this.onSeniorPriceChange.bind(this);
    this.createTournament = this.createTournament.bind(this);

    this.onStartDateTimeChange = this.onStartDateTimeChange.bind(this);
    this.onRegistrationStartDateTimeChange = this.onRegistrationStartDateTimeChange.bind(this);
    this.onRegistrationEndDateTimeChange = this.onRegistrationEndDateTimeChange.bind(this);
  }

  render() {
    return (
      <div>
        <AdminNavigationBar />
        <div className="container">
          <h1>Nowy turniej</h1>
          { this.state.created ? <div className="inline-block alert alert-info">Utworzono turniej.</div> : ''}
          { this.state.error ? <div className="inline-block alert alert-danger">{this.state.error}</div> : '' }
          <form>
            <div className="row">
              <div className="col col-md-6">
                <div className="form-group col-md-6">
                  <label>Typ: </label>
                  <select className="form-control" value={this.state.type} onChange={this.onTypeChange()}>
                    <option value="PAIRS">Turniej par</option>
                    <option value="INDIVIDUAL">Indywiduel</option>
                    <option value="TEAM4">Turniej teamów 4-osobowych</option>
                    <option value="TEAM6">Turniej teamów 4..6-osobowych</option>
                  </select>
                </div>
                <div className="form-row col-md-12">
                  <div className="form-group col-md-6">
                    <label>Nazwa:</label>
                    <input
                      type="text"
                      className={"form-control " + this.validationClass('name')}
                      value={this.state.name}
                      onChange={this.onNameChange()}></input>
                  </div>
                  <div className="form-group col-md-4">
                    <label>Ranga:</label>
                    <select id="inputState" value={this.state.rank} onChange={this.onRankChange()} className="form-control">
                      {
                        Object.keys(rankFilters).map(value => {
                          return (<option value={value}>{rankFilters[value]}</option>);
                        })
                      }
                    </select>
                  </div>
                </div>
                <div className="form-row col-md-12">
                  <div className="form-group col-md-4">
                    <label>Miejscowość:</label>
                    <input
                      type="text"
                      className={"form-control " + this.validationClass('shortDescription')}
                      value={this.state.shortDescription}
                      onChange={this.onShortDescriptionChange()}></input>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Województwo:</label>
                    <select id="inputState" value={this.state.locationCode} onChange={this.onLocationCodeChange()} className="form-control">
                      {
                        Object.keys(locationFilters).map(value => {
                          return (<option value={value}>{locationFilters[value]}</option>);
                        })
                      }
                    </select>
                  </div>
                </div>
                <div className="form-group col-md-12">
                  <label>Opis:</label>
                  <div>
                    <textarea
                      className={"form-control " + this.validationClass('detailedDescription')}
                      value={this.state.detailedDescription}
                      onChange={this.onDetailedDescriptionChange()}></textarea>
                  </div>
                </div>
                <div className="form-group col-md-6">
                  <label>Kontakt (e-mail lub telefon):</label>
                  <input
                    type="text"
                    className={"form-control " + this.validationClass('contact')}
                    value={this.state.contact}
                    onChange={this.onContactChange()}></input>
                </div>
                <div className="form-group col-md-6">
                  <label>Czas rozpoczęcia turnieju:</label>
                  <Flatpickr
                    className={"form-control " + this.validationClass('startTime')}
                    data-enable-time
                    data-position="above"
                    data-time_24hr
                    data-allow-input="true"
                    data-date-format="d.m.Y H:i"
                    value={this.state.startDateTime}
                    onChange={this.onStartDateTimeChange} />
                </div>
                <div className="form-row col-md-12">
                  <div className="form-group col-md-6">
                    <label>Rejestracja od:</label>
                    <Flatpickr
                      className={"form-control " + this.validationClass('registrationInfo.startTime')}
                      data-enable-time
                      data-position="above"
                      data-time_24hr
                      data-allow-input="true"
                      data-date-format="d.m.Y H:i"
                      value={this.state.registrationStartDateTime}
                      onChange={this.onRegistrationStartDateTimeChange} />
                  </div>
                  <div className="form-group col-md-6">
                    <label>do:</label>
                    <Flatpickr
                      className={"form-control " + this.validationClass('registrationInfo.endTime')}
                      data-enable-time
                      data-position="above"
                      data-time_24hr
                      data-allow-input="true"
                      data-date-format="d.m.Y H:i"
                      value={this.state.registrationEndDateTime}
                      onChange={this.onRegistrationEndDateTimeChange} />
                  </div>
                </div>
                <div className="form-group col-md-6">
                  <label>Limit zgłoszeń:</label>
                  <input
                    type="number"
                    className={"form-control " + this.validationClass('registrationInfo.participantLimit')}
                    min="1"
                    step="1"
                    value={this.state.participantLimit}
                    onChange={this.onParticipantLimitChange()}></input>
                </div>
                <div className="form-group col-md-6">
                  <button className="btn btn-primary" onClick={this.createTournament}>Utwórz</button>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group col-md-12">
                  <input type="checkbox" checked={this.state.paymentsEnabled} onChange={this.togglePayments()}></input> Włącz płatności
                </div>
                <div style={this.state.paymentsEnabled ? {} : {display: 'none'}}>
                  <div className="form-group col-md-12">
                    <input type="checkbox" checked={this.state.mandatoryPayment} onChange={this.toggleMandatoryPayment()}></input> Płatność obowiązkowa
                  </div>
                  <div className="form-group col-md-12">
                    <h3>Wpisowe</h3>
                    <div className="input-group aligned-prepend col-md-9 mb-3">
                      <div className="form-group col-md-9">
                        <label>Typ: </label>
                        <select className="form-control" value={this.state.pricingType} onChange={this.onPricingTypeChange()}>
                          <option value="PLAYER">Od zawodnika</option>
                          <option value="PARTICIPANT">Od zgłoszenia</option>
                        </select>
                      </div>
                    </div>
                    <div style={this.state.pricingType === 'PLAYER' ? {} : {display: 'none'}}>
                      <div className="input-group aligned-prepend col-md-9 mb-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text">Niezrzeszony</span>
                        </div>
                        <input
                          type="number"
                          className={"form-control " + this.validationClass('pricing.nonAssociatedPlayerPrice')}
                          min="0"
                          step="1"
                          value={this.state.nonAssociatedPlayerPrice}
                          onChange={this.onNonAssociatedPlayerPriceChange()}></input>
                        <div className="input-group-append">
                          <span className="input-group-text">zł</span>
                        </div>
                      </div>
                      <div className="input-group aligned-prepend col-md-9 mb-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text">Normalny</span>
                        </div>
                        <input
                          type="number"
                          className={"form-control " + this.validationClass('pricing.regularPrice')}
                          min="0"
                          step="1"
                          value={this.state.regularPrice}
                          onChange={this.onRegularPriceChange()}></input>
                        <div className="input-group-append">
                          <span className="input-group-text">zł</span>
                        </div>
                      </div>
                      <div className="input-group aligned-prepend col-md-9 mb-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text">Młodzież szkolna</span>
                        </div>
                        <input
                          type="number"
                          className={"form-control " + this.validationClass('pricing.youngsterPrice')}
                          min="0"
                          step="1"
                          value={this.state.youngsterPrice}
                          onChange={this.onYoungsterPriceChange()}></input>
                        <div className="input-group-append">
                          <span className="input-group-text">zł</span>
                        </div>
                      </div>
                      <div className="input-group aligned-prepend col-md-9 mb-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text">Junior</span>
                        </div>
                        <input
                          type="number"
                          className={"form-control " + this.validationClass('pricing.juniorPrice')}
                          min="0"
                          step="1"
                          value={this.state.juniorPrice}
                          onChange={this.onJuniorPriceChange()}></input>
                        <div className="input-group-append">
                          <span className="input-group-text">zł</span>
                        </div>
                      </div>
                      <div className="input-group aligned-prepend col-md-9 mb-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text">Senior</span>
                        </div>
                        <input
                          type="number"
                          className={"form-control " + this.validationClass('pricing.seniorPrice')}
                          min="0"
                          step="1"
                          value={this.state.seniorPrice}
                          onChange={this.onSeniorPriceChange()}></input>
                        <div className="input-group-append">
                          <span className="input-group-text">zł</span>
                        </div>
                      </div>
                    </div>
                    <div style={this.state.pricingType === 'PARTICIPANT' ? {} : {display: 'none'}}>
                      <div className="input-group aligned-prepend col-md-9 mb-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text">Zrzeszeni z opłaconą składką</span>
                        </div>
                        <input
                          type="number"
                          className={"form-control " + this.validationClass('pricing.associatedParticipantPrice')}
                          min="0"
                          step="1"
                          value={this.state.associatedParticipantPrice}
                          onChange={this.onAssociatedParticipantPriceChange()}></input>
                        <div className="input-group-append">
                          <span className="input-group-text">zł</span>
                        </div>
                      </div>
                      <div className="input-group aligned-prepend col-md-9 mb-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text">Pozostali</span>
                        </div>
                        <input
                          type="number"
                          className={"form-control " + this.validationClass('pricing.nonAssociatedParticipantPrice')}
                          min="0"
                          step="1"
                          value={this.state.nonAssociatedParticipantPrice}
                          onChange={this.onNonAssociatedParticipantPriceChange()}></input>
                        <div className="input-group-append">
                          <span className="input-group-text">zł</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }

  validationClass(fieldName) {
    if (this.state.invalidFields && this.state.invalidFields.includes(fieldName)) {
      return 'is-invalid';
    } else {
      return '';
    }
  }

  togglePayments() {
    return (evt) => {
      this.setState({paymentsEnabled: !this.state.paymentsEnabled});
    };
  }

  toggleMandatoryPayment() {
    return (evt) => {
      this.setState({mandatoryPayment: !this.state.mandatoryPayment});
    };
  }

  onPricingTypeChange() {
    return (evt) => {
      this.setState({pricingType: evt.target.value});
    };
  }

  onNonAssociatedPlayerPriceChange() {
    return (evt) => {
      this.setState({nonAssociatedPlayerPrice: evt.target.value});
    };
  }

  onRegularPriceChange() {
    return (evt) => {
      this.setState({regularPrice: evt.target.value});
    };
  }

  onYoungsterPriceChange() {
    return (evt) => {
      this.setState({youngsterPrice: evt.target.value});
    };
  }

  onJuniorPriceChange() {
    return (evt) => {
      this.setState({juniorPrice: evt.target.value});
    };
  }

  onSeniorPriceChange() {
    return (evt) => {
      this.setState({seniorPrice: evt.target.value});
    };
  }

  onNonAssociatedParticipantPriceChange() {
    return (evt) => {
      this.setState({nonAssociatedParticipantPrice: evt.target.value});
    };
  }

  onAssociatedParticipantPriceChange() {
    return (evt) => {
      this.setState({associatedParticipantPrice: evt.target.value});
    };
  }

  createTournament() {
    const tournamentType = this.state.type.startsWith('TEAM') ? 'TEAMS' : this.state.type;

    let minPlayers = 0;
    let maxPlayers = 0;

    switch (this.state.type) {
      case 'PAIRS':
        minPlayers = 2;
        maxPlayers = 2;
        break;
      case 'INDIVIDUAL':
        minPlayers = 1;
        maxPlayers = 1;
        break;
      case 'TEAM4':
        minPlayers = 4;
        maxPlayers = 4;
        break;
      case 'TEAM6':
        minPlayers = 4;
        maxPlayers = 6;
        break;
      default:
        break;
    }

    let pricing = undefined;
    let paymentMode = 'DISABLED';

    if (this.state.paymentsEnabled) {
      paymentMode = this.state.mandatoryPayment ? 'MANDATORY' : 'OPTIONAL';

      if (this.state.pricingType === 'PLAYER') {
        pricing = {
          type: this.state.pricingType,
          nonAssociatedPlayerPrice: this.state.nonAssociatedPlayerPrice,
          regularPrice: this.state.regularPrice,
          youngsterPrice: this.state.youngsterPrice,
          juniorPrice: this.state.juniorPrice,
          seniorPrice: this.state.seniorPrice
        };
      } else if (this.state.pricingType === 'PARTICIPANT') {
        pricing = {
          type: this.state.pricingType,
          nonAssociatedParticipantPrice: this.state.nonAssociatedParticipantPrice,
          associatedParticipantPrice: this.state.associatedParticipantPrice,
        };
      }
    }

    fetch(
      `/api/tournaments`,
      {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          type: tournamentType,
          minPlayers: minPlayers,
          maxPlayers: maxPlayers,
          rank: this.state.rank,
          name: this.state.name,
          shortDescription: this.state.shortDescription,
          detailedDescription: this.state.detailedDescription,
          contact: this.state.contact,
          locationCode: this.state.locationCode,
          startTime: this.state.startDateTime ? new Date(this.state.startDateTime).toISOString() : null,
          registrationInfo: {
            participantLimit: this.state.participantLimit,
            startTime: this.state.registrationStartDateTime ? new Date(this.state.registrationStartDateTime).toISOString() : null,
            endTime: this.state.registrationEndDateTime ? new Date(this.state.registrationEndDateTime).toISOString() : null
          },
          paymentMode: paymentMode,
          pricing: pricing
        })
      }).then(response => {
        if (response.status === 200) {
          response.json().then(tournament => location.href = '#/admin/tournaments/' + tournament.id.toString() + '/participants');
        } else {
          response.json().then(data => this.setState({
            error: 'Nie podano wszystkich danych!',
            invalidFields: data.errors
          }));
        }
      });
  }

  mergeDateWithTime(date, time) {
    if (date && time) {
      return new Date(date + ' ' + time).toISOString(); 
    } else {
      return null;
    }
  }

  onTypeChange() {
    return (evt) => {
      this.setState({ type: evt.target.value });
    };
  }

  onNameChange() {
    return (evt) => {
      this.setState({ name: evt.target.value });
    };
  }

  onRankChange() {
    return (evt) => {
      this.setState({ rank: evt.target.value });
    };
  }

  onLocationCodeChange() {
    return (evt) => {
      this.setState({ locationCode: evt.target.value });
    };
  }

  onShortDescriptionChange() {
    return (evt) => {
      this.setState({ shortDescription: evt.target.value });
    };
  }

  onDetailedDescriptionChange() {
    return (evt) => {
      this.setState({ detailedDescription: evt.target.value });
    };
  }

  onContactChange() {
    return (evt) => {
      this.setState({ contact: evt.target.value });
    };
  }

  onParticipantLimitChange() {
    return (evt) => {
      this.setState({ participantLimit: parseInt(evt.target.value, 10) });
    };
  }

  onStartDateTimeChange(value) {
    const newValue = value[0];

    if (newValue && !this.state.registrationEndDateTime) {
      this.setState({
        startDateTime: newValue,
        registrationEndDateTime: moment(newValue).hour(0).minute(0).second(0).millisecond(0).toDate(),
      });
    } else {
      this.setState({ startDateTime: newValue });
    }
  }

  onRegistrationStartDateTimeChange(value) {
    this.setState({ registrationStartDateTime: value[0] });
  }

  onRegistrationEndDateTimeChange(value) {
    this.setState({ registrationEndDateTime: value[0] });
  }
}

function emptyState() {
  const now = moment();

  return {
    type: 'PAIRS',
    name: '',
    rank: 'LOCAL',
    shortDescription: '',
    locationCode: 'MA',
    detailedDescription: '',
    contact: '',
    startDateTime: '',
    registrationStartDateTime: now.toDate(),
    registrationEndDateTime: '',
    participantLimit: '',
    paymentsEnabled: false,
    mandatoryPayment: false,
    pricingType: 'PLAYER',
    nonAssociatedPlayerPrice: undefined,
    regularPrice: undefined,
    youngsterPrice: undefined,
    juniorPrice: undefined,
    seniorPrice: undefined,
    nonAssociatedParticipantPrice: undefined,
    associatedParticipantPrice: undefined,
  };
}

export default TournamentCreator;



// WEBPACK FOOTER //
// ./components/TournamentCreator.js